<div *ngIf="!!company" class="card">
  <div class="card-header">
    {{ company.company }}
  </div>
  <div class="card-block">
    <p class="card-text">
      {{ company.street }}<br />{{ company.postcode }} {{ company.city }}
    </p>
  </div>
  <ul class="list-group">
    <li class="list-group-item" *ngIf="company.phone" (click)="makeACall = true">Telefon: {{ company.phone }}</li>
    <li class="list-group-item" *ngIf="company.email">E-Mail: {{ company.email }}</li>
  </ul>
  <div class="card-footer">
    <button class="btn btn-sm btn-link" [routerLink]="['/contact/details', company.cid ]">Zur Firma</button>
  </div>
</div>

<clr-modal *ngIf="company" [(clrModalOpen)]="makeACall" [clrModalStaticBackdrop]="false">
  <h3 class="modal-title">Möchten Sie {{ company.company }} anrufen?</h3>
  <div class="modal-body">
    <p><a [attr.href]="callUrl(company.phone)">{{ company.phone }}</a></p>
    <small>(Anruf wird an Telefonanlage übergeben)</small>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline" (click)="makeACall = false">Abbrechen</button>
    <button type="button" class="btn btn-primary" (click)="startCall(company.phone)">JETZT ANRUFEN</button>
  </div>
</clr-modal>
